import { render, staticRenderFns } from "./BeforeInfo.vue?vue&type=template&id=bbcfc6a4&scoped=true"
import script from "./BeforeInfo.vue?vue&type=script&lang=js"
export * from "./BeforeInfo.vue?vue&type=script&lang=js"
import style0 from "./BeforeInfo.vue?vue&type=style&index=0&id=bbcfc6a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcfc6a4",
  null
  
)

export default component.exports